import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackId"];
import { useAchievementImages } from '../achievementImagesQueries';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
export const CertificateBadge = _ref => {
  let {
      trackId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    images: {
      badgeURL
    }
  } = useAchievementImages({
    trackId
  });
  return /*#__PURE__*/_jsx(Image, Object.assign({
    "data-category": "badge",
    responsive: true,
    src: badgeURL || ''
  }, props));
};